var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65359 4.94975C5.01825 4.94975 6.12846 3.83955 6.12849 2.47488C6.12849 1.11021 5.01823 0 3.65359 0C2.28894 0 1.17871 1.11021 1.17871 2.47488C1.17871 3.83955 2.28892 4.94975 3.65359 4.94975Z",
    fill: "#0056CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34661 4.94975C10.7113 4.94975 11.8215 3.83955 11.8215 2.47488C11.8215 1.11021 10.7113 0 9.34661 0C7.98191 0 6.8717 1.11021 6.8717 2.47488C6.8717 3.83955 7.98196 4.94975 9.34661 4.94975Z",
    fill: "#0056CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65353 5.3833C1.63896 5.3833 0 7.02214 0 9.03655V10.2756C0 10.5288 0.205309 10.7341 0.458555 10.7341H6.84821C7.10145 10.7341 7.30676 10.5288 7.30676 10.2756V9.03655C7.30676 7.04301 5.70032 5.3833 3.65353 5.3833Z",
    fill: "#0056CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03928 6.20064C6.97509 6.25325 6.96613 6.3479 7.01731 6.41323C8.06303 7.74711 7.91812 9.0368 7.91812 10.2753C7.91812 10.368 7.90626 10.4579 7.88397 10.5437C7.85894 10.6401 7.93236 10.7339 8.03192 10.7339H12.5414C12.7947 10.7339 13 10.5285 13 10.2753V9.03626C13 5.93018 9.3761 4.28573 7.03928 6.20064Z",
    fill: "#0056CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerPeople);
export default __webpack_public_path__ + "static/media/banner-people.095b8c38.svg";
export { ForwardRef as ReactComponent };